import { FsgmLocaleType, ListItemReferenceModel } from '@common-lib';

import { AccountModel } from '../account';
import { MetadataModel } from '../common';

export interface UserModel extends MetadataModel {
  id: string;
  employeeId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  locale: FsgmLocaleType;
  displayName: string;
  email: string;
  initials: string | undefined;
  joinedAt: string;
  accounts: AccountModel[];
  defaultAccountId: string | undefined;
  client: ListItemReferenceModel;
  operator: ListItemReferenceModel;
  preferences: UserPreferencesModel | undefined;
}

export const NotificationCategories = [
  'ORDER_UPDATES',
  'OFFERS',
  'MENU_CHANGES',
  'EVENTS',
  'GENERAL',
] as const;

export type NotificationCategory = (typeof NotificationCategories)[number];

export type NotificationCategoryPreferencesModel = Record<
  NotificationCategory,
  boolean
>;

export interface UserPreferencesModel {
  sites: string[];
  hidden: HiddenPreferencesModel | undefined;
  onboarding: OnboardingPreferencesModel | undefined;
  notificationCategories: NotificationCategoryPreferencesModel | undefined;
}

export const OnboardingSteps = [
  'NAME_AND_LANGUAGE',
  'PUSH_NOTIFICATIONS',
] as const;

export type OnboardingStep = (typeof OnboardingSteps)[number];

export interface OnboardingPreferencesModel {
  onboarded: boolean;
  version: number;
  stepsPerformed: OnboardingStep[] | undefined;
}

export interface HiddenPreferencesModel {
  balances: string[];
  infoPanels: HiddenInfoPanelModel[];
}

export const AllowedHiddenInfoPanelTypes = [
  'TOP_LEVEL_NEWS',
  'SITE_UNIT_NEWS',
] as const;

export type HiddenInfoPanelModel = (typeof AllowedHiddenInfoPanelTypes)[number];
